import React from "react";
import { Circle } from "arkh";

import { graphql, useFragment } from "react-relay";
import { TeamScheduleSectionHeaderStatusDot_routineOccasion$key } from "./__generated__/TeamScheduleSectionHeaderStatusDot_routineOccasion.graphql";

export const TeamScheduleSectionHeaderStatusDot = React.memo(
  TeamScheduleSectionHeaderStatusDotC
);
function TeamScheduleSectionHeaderStatusDotC(props: {
  occasion: TeamScheduleSectionHeaderStatusDot_routineOccasion$key;
}) {
  const occasion = useFragment(
    graphql`
      fragment TeamScheduleSectionHeaderStatusDot_routineOccasion on RoutineOccasion {
        status(calculateNoTasks: true, calculateNotCompletedStarted: true)
        totalTaskExecutionCount
      }
    `,
    props.occasion
  );

  switch (occasion.status) {
    case "FUTURE":
      return <Circle size="dot" borderColor="neutral" borderWidth={1.5} />;
    case "REQUIRED_COMPLETED":
    case "COMPLETED":
      return <Circle size="dot" color="positive" />;
    case "NOT_COMPLETED_STARTED":
      return <Circle size="dot" color="semiNegative" />;
    case "NOT_COMPLETED":
      return <Circle size="dot" color="negative" />;
    case "IN_PROGRESS":
      return <Circle size="dot" borderColor="primary" borderWidth={1.5} />;
    case "IN_PROGRESS_EXPIRED":
      return <Circle size="dot" color="negative" />;
    case "NO_TASKS_COMPLETED":
      return <Circle size="dot" color="border-primary" />;
    default:
      return <Circle size="dot" color="surface" />;
  }
}
